export const basePath = '/settings/segments'
export type SavedFiltersTab = 'phone' | 'email'
export const routes = {
  root: basePath,
  tab: (subPath: SavedFiltersTab): string => {
    return `${basePath}/${subPath}`
  },
}
